<!-- Do not change this file. -->

<template>
  <header class="navbar navbar-dark bg-dark">
    <div class="container-fluid">
      <div
        class="
          navbar-brand
          d-flex
          align-items-center
          justify-content-between
          w-100
        "
        role="banner"
      >
        <div class="d-flex align-items-center">
          <img
            src="@/assets/logo-dark.svg"
            alt="Oregon State University Logo"
            height="30"
            class="d-inline-flex align-top me-3 pe-3 border-end"
          />
          <h1 class="h5 d-flex align-items-center m-0">
            <span class="title me-3 fw-bold">{{ course }}</span>
            <!-- Displayed for medium and large screens -->
            <span class="subtitle d-none d-sm-block">{{ title }}</span>
            <!-- Displayed only for small screens -->
            <span class="subtitle d-sm-none">{{ shortTitle }}</span>
          </h1>
        </div>
        <div class="d-flex align-items-center">
          <!-- Dropdown menu to select the preset -->
          <div class="dropdown me-3">
            <button
              class="btn btn-outline-light dropdown-toggle"
              type="button"
              id="presetDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Presets
            </button>
            <ul class="dropdown-menu" aria-labelledby="presetDropdown">
              <li v-for="preset in planetPresets" :key="preset.name">
                <button @click="setPreset(preset)" class="dropdown-item">
                  {{ preset.label }}
                </button>
              </li>
            </ul>
          </div>

          <div class="dropdown me-3">
            <button
              class="btn btn-outline-light dropdown-toggle"
              type="button"
              id="presetDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ unitLabel }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="presetDropdown">
              <li>
                <button @click="setTemperatureUnit('C')" class="dropdown-item">
                  Celsius (°C)
                </button>
                <button @click="setTemperatureUnit('F')" class="dropdown-item">
                  Fahrenheit (°F)
                </button>
                <button @click="setTemperatureUnit('K')" class="dropdown-item">
                  Kelvin (K)
                </button>
              </li>
            </ul>
          </div>

          <ActivityInstructions />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
/* Do not change this file. */

import config from "@/data/config";
import ActivityInstructions from "@/components/activity/ActivityInstructions.vue";
import planetPresets from "@/data/planet_presets.json";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Header",
  components: {
    ActivityInstructions
  },
  data() {
    return {
      course: config.meta.course,
      title: config.meta.title,
      shortTitle: config.meta.shortTitle,
      planetPresets
    };
  },
  computed: {
    ...mapGetters(["temperatureUnit"]),
    unitLabel() {
      switch (this.temperatureUnit) {
        case "C":
          return "Celsius (°C)";
        case "F":
          return "Fahrenheit (°F)";
        case "K":
          return "Kelvin (K)";
        default:
          return "Unknown";
      }
    }
  },
  methods: {
    ...mapActions(["setTemperatureUnit", "setPreset"]),
    toggleTemperatureUnit() {
      if (this.temperatureUnit !== "C" && this.temperatureUnit !== "F") {
        console.error("Invalid temperature unit");
        return;
      }
      this.temperatureUnit === "C"
        ? this.setTemperatureUnit("F")
        : this.setTemperatureUnit("C");
    }
  }
};
</script>
